import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// 현재 사용자 정보 (나중에 인증 시스템과 연동)
const CURRENT_USER = {
  id: 'user_current',
  name: '나',
  department: 'IT부'
};

// 부서 목록
export const DEPARTMENTS = [
  { id: 'all', label: '전체' },
  { id: 'IT부', label: 'IT부' },
  { id: '산업부', label: '산업부' },
  { id: '경제부', label: '경제부' },
  { id: '사회부', label: '사회부' },
  { id: '정치부', label: '정치부' },
];

export const useTeamStore = create(
  persist(
    (set, get) => ({
  // State
  works: [],
  selectedWork: null,
  filter: 'all', // all | table | document | search
  department: 'all', // all | IT부 | 산업부 | 경제부 | 사회부 | 정치부
  sortBy: 'recent', // recent | popular | myDepartment
  currentUser: CURRENT_USER,
  isLoading: false,
  isModalOpen: false,
  shareData: null, // Data to be shared

  // Actions
  setWorks: (works) => set({ works }),

  setSelectedWork: (work) => set({ selectedWork: work }),

  setFilter: (filter) => set({ filter }),

  setDepartment: (department) => set({ department }),

  setSortBy: (sortBy) => set({ sortBy }),

  setLoading: (loading) => set({ isLoading: loading }),

  openShareModal: (data) => set({ isModalOpen: true, shareData: data }),

  closeShareModal: () => set({ isModalOpen: false, shareData: null }),

  addWork: (work) => set((state) => ({
    works: [work, ...state.works]
  })),

  updateWorkLikes: (workId, likes, likedBy) => set((state) => ({
    works: state.works.map((w) =>
      w.id === workId ? { ...w, likes, likedBy } : w
    ),
    selectedWork: state.selectedWork?.id === workId
      ? { ...state.selectedWork, likes, likedBy }
      : state.selectedWork
  })),

  toggleLike: (workId, userId) => set((state) => {
    const work = state.works.find((w) => w.id === workId);
    if (!work) return state;

    const likedBy = work.likedBy || [];
    const isLiked = likedBy.includes(userId);
    const newLikedBy = isLiked
      ? likedBy.filter((id) => id !== userId)
      : [...likedBy, userId];
    const newLikes = newLikedBy.length;

    return {
      works: state.works.map((w) =>
        w.id === workId ? { ...w, likes: newLikes, likedBy: newLikedBy } : w
      ),
      selectedWork: state.selectedWork?.id === workId
        ? { ...state.selectedWork, likes: newLikes, likedBy: newLikedBy }
        : state.selectedWork
    };
  }),

  addComment: (workId, comment) => set((state) => ({
    works: state.works.map((w) =>
      w.id === workId
        ? { ...w, comments: [...(w.comments || []), comment], commentCount: (w.commentCount || 0) + 1 }
        : w
    ),
    selectedWork: state.selectedWork?.id === workId
      ? { ...state.selectedWork, comments: [...(state.selectedWork.comments || []), comment], commentCount: (state.selectedWork.commentCount || 0) + 1 }
      : state.selectedWork
  })),

  deleteComment: (workId, commentId) => set((state) => ({
    works: state.works.map((w) =>
      w.id === workId
        ? {
            ...w,
            comments: (w.comments || []).filter(c => c.id !== commentId),
            commentCount: Math.max((w.commentCount || 0) - 1, 0)
          }
        : w
    ),
    selectedWork: state.selectedWork?.id === workId
      ? {
          ...state.selectedWork,
          comments: (state.selectedWork.comments || []).filter(c => c.id !== commentId),
          commentCount: Math.max((state.selectedWork.commentCount || 0) - 1, 0)
        }
      : state.selectedWork
  })),

  // Getters
  getFilteredWorks: () => {
    const { works, filter, department, sortBy, currentUser } = get();

    let filtered = works;

    // Type filter
    if (filter !== 'all') {
      filtered = filtered.filter((w) => w.workType === filter);
    }

    // Department filter
    if (department !== 'all') {
      filtered = filtered.filter((w) => w.department === department);
    }

    // Sorting
    switch (sortBy) {
      case 'popular':
        filtered = [...filtered].sort((a, b) => (b.likes || 0) - (a.likes || 0));
        break;
      case 'myDepartment':
        // 내 부서 먼저, 그 다음 최신순
        filtered = [...filtered].sort((a, b) => {
          const aIsMine = a.department === currentUser.department ? 1 : 0;
          const bIsMine = b.department === currentUser.department ? 1 : 0;
          if (aIsMine !== bIsMine) return bIsMine - aIsMine;
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        break;
      case 'recent':
      default:
        filtered = [...filtered].sort((a, b) =>
          new Date(b.createdAt) - new Date(a.createdAt)
        );
        break;
    }

    return filtered;
  }
}),
    {
      name: 'labs-team-store',
      partialize: (state) => ({
        works: state.works, // works만 persist
      })
    }
  )
);
